import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IPage, IPageSize, ISort, TDefaultStoreNoSearchDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

const initialState: TDefaultStoreNoSearchDTO = {
	sortDirection: false,
	sortFieldName: null,
	...defaultMeta,
};

const schemaConfig = createSlice({
	name: 'schemaConfig',
	initialState,
	reducers: {
		setSort: (
			state,
			action: PayloadAction<ISort>,
		) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		resetSchemaConfig: () => initialState,
	},
});

export const {
	setSort,
	setPage,
	setPageSize,
	resetSchemaConfig,
} = schemaConfig.actions;

export default schemaConfig.reducer;
